import { Menu, MenuItem } from "@material-ui/core";
import React from "react";
import DeleteIcon from "@material-ui/icons/Delete";

const MenuManageGuests = ({
  idManageGuests,
  item,
  anchorEl,
  anchorSelected,
  handleCloseActions,
  setAnchorEl,
  setAnchorSelected,
  setOpenDeleteModal,
}) => {
  return (
    <Menu
      id="long-menu"
      anchorEl={anchorEl}
      open={Boolean(anchorSelected === idManageGuests ? true : false)}
      keepMounted
      transition={"true"}
      onClose={() => handleCloseActions()}
    >
      <MenuItem
        onClick={() => {
          setAnchorEl(null);
          setAnchorSelected(null);
          setOpenDeleteModal(item);
        }}
      >
        <DeleteIcon />
        &nbsp; Delete
      </MenuItem>
    </Menu>
  );
};

export default MenuManageGuests;
